import { Component } from 'react';

import { loadNotifications } from 'common/actions/notifications';
import cloneElementWithProps from 'common/core/cloneElementWithProps';
import connect from 'common/core/connect';

import type { NotificationsState } from 'common/reducers/notifications';
import type { State } from 'redux-connect';

type OwnProps = {
  children: React.ReactNode;
};
type ConnectProps = {
  loadNotifications: () => void;
  notifications: NotificationsState;
};

type Props = OwnProps & ConnectProps;

class CompanyNotificationsContainer extends Component<Props> {
  componentDidMount() {
    this.props.loadNotifications();
  }

  render() {
    const { children, notifications } = this.props;

    return cloneElementWithProps(children, {
      ...this.props,
      notifications,
    });
  }
}

export default connect((state: State) => ({ notifications: state.notifications }), {
  loadNotifications,
})(CompanyNotificationsContainer) as unknown as React.ComponentClass<OwnProps>;
